<template>
    <div>
        <veui-dialog
            overlay-class="authentice-style"
            ui="narrow"
            title="温馨提示"
            :open="(modalOpen && show) || (showConfirmLawyerDialog && show)"
            @ok="handleModalClose"
            @cancel="handleModalClose"
        >
            <span style="white-space: pre-line;">{{
                unAuthenticeContent.content
            }}</span>
            <template #foot>
                <veui-button ui="s primary" @click="handleGoAuthentice">
                    {{ unAuthenticeContent.button }}
                </veui-button>
                <veui-button ui="s primary" @click="handleModalClose">
                    稍后再说
                </veui-button>
            </template>
        </veui-dialog>
    </div>
</template>

<script>
/**
 * @file authentice-dialog.vue
 * @author baoleilei
 * @desc 律师个人认证信息未填写完成弹窗
 */
import {Dialog, Button} from 'veui';
import {mapState} from 'vuex';
export default {
    name: 'authentice-dialog',
    components: {
        'veui-dialog': Dialog,
        'veui-button': Button
    },
    props: {
        //    info_status 代表资料状态
        //     0 = 编辑中
        //     2 = 审核中
        //     4 = 执业审核成功
        //     6 = 执业审核失败
        //    10 = 律师已入驻，未认证

        //     audit_status 代表大的审核状态
        //     0 = 未认证
        //     4 = 已认证
        //     6 = 认证失败
        show: {
            type: Boolean,
            default: false
        },
        // 弹窗信息
        info: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        ...mapState({
            authenticationStatus: state =>
                state.lawStore.authenticationStatus,
            userInfo: state =>
                state.lawStore.userInfoNew
        }),
        unAuthenticeContent() {
            if (this.showConfirmLawyerDialog) {
                return {
                    content: '为了保证百家号用户的信息权威度，需要您补充部分个人信息，请前往我的认证页面查看。',
                    button: '去查看'
                };
            }
            let contents = {
                4: '为保证百度用户的搜索体验并提升您在搜索结果中的信息权威度，此功能需您补充律师个人信息并通过审核后使用',
                5: '为保证百度用户的搜索体验并提升您在搜索结果中的信息权威度，此功能需您补充律师个人信息并通过审核后使用，当前您的个人信息审核处于审核中或审核失败状态，请前往我的认证页面查看',
                6: '为保证百度用户的搜索体验并提升您在搜索结果中的信息权威度，此功能需您补充律师个人信息并通过审核后使用，当前您的个人信息审核处于审核中或审核失败状态，请前往我的认证页面查看'
            };
            let button = {
                4: '去填写',
                6: '去查看',
                5: '去查看'
            };
            return {
                content: contents[this.authenticationStatus] || '',
                button: button[this.authenticationStatus] || '去查看'
            };
        },
        showConfirmLawyerDialog() {
            const userInfo = this.userInfo || {};
            const {lawyer_info = {}} = userInfo;
            const {
                name,
                personal_intro,
                personal_avatar,
                identity_national_image,
                identity_head_image
            } = lawyer_info || {};
            if (!name
                || !personal_intro
                || !personal_avatar
                || !identity_national_image
                || !identity_head_image) {
                return true;
            }
            return false;
        }
    },
    data() {
        return {
            modalOpen: false
        };
    },
    watch: {
        authenticationStatus: {
            immediate: true,
            handler(val) {
                if (val && val !== 7) {
                    this.modalOpen = true;
                }
            }
        },
        show: {
            handler(val) {
                val && (this.modalOpen || this.showConfirmLawyerDialog) && this.$wywLog.send({
                    serverId: 18745,
                    action: 'show',
                    area: 'bqxx'
                });
            },
            immediate: true
        }
    },
    methods: {
        handleGoAuthentice() {
            const isEdit = this.authenticationStatus === 4;
            this.$router.push({
                path: '/material',
                query: {
                    ...(isEdit && {
                        isEdit: 'edit',
                        editAnchor: 'authentice_title'
                    })
                }
            });
            this.$wywLog.send({
                serverId: 18745,
                action: 'click',
                area: 'view-btn'
            });
            this.handleModalClose();
        },
        handleModalClose() {
            this.$wywLog.send({
                serverId: 18745,
                action: 'click',
                area: 'bqxx-close-btn'
            });
            this.$emit('handleModalClose');
        }
    }
};
</script>

<style lang="less" scoped>
.authentice-style {
    /deep/ .veui-dialog-content {
        width: 420px;
        border-radius: 8px;

        .veui-dialog-content-head {
            padding: 24px;
            position: relative;

            .veui-dialog-content-head-title {
                font-family: PingFangSC-Medium;
                font-size: 18px;
                color: #1e1f24;
            }

            .veui-dialog-content-head-close {
                position: absolute;
                top: 24px;
                right: 24px;
            }
        }

        .veui-dialog-content-body {
            padding: 0 24px;
            font-size: 16px;
            line-height: 24px;
            color: #1e1f24;
        }

        .veui-dialog-content-foot {
            padding: 24px 24px 0;
            display: flex;
            flex-direction: row-reverse;
            justify-content: center;

            .veui-button {
                font-size: 16px;
                padding: 0 24px;
                height: 40px;
                background: #05f;
            }

            .veui-button + .veui-button {
                font-size: 16px;
                margin: 0 24px 0 0;
                border: 1px solid #05f;
                background: #fff;
                color: #05f;
            }
        }
    }
}
</style>
